import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import { CardActionArea } from "@mui/material";
import Link from "@mui/material/Link";
import steve from "../../../assets/advisory/steve.jpg";
// import obasanjo from "../../../assets/advisory/obasanjo.jpg";
import oluseun from "../../../assets/advisory/oluseun.jpg";
import prof from "../../../assets/advisory/prof.png";
import iyadunni from "../../../assets/advisory/iyadunni.jpg";
import adebayo from "../../../assets/advisory/adebayo.jpg";
import edna from "../../../assets/advisory/edna.png";

const data = [
  // {
  //   imgpath: obasanjo,
  //   name: "Olusegun Obasanjo Ph.D",
  //   title: "Grand Advisor",
  //   profile:
  //     " Chief Olusegun Aremu Obasanjo, GCFR, Ph.D, a great farmer, a soldier, a peer of the realm for Africa who inspires the future of the African youths. He has more than 60 years’ experience on Governance, Leadership...",
  //   link: "/advisory-council/olusegun-obasanjo",
  // },
  // {
  //   imgpath: steve,
  //   name: "Steve Okeleji",
  //   title: "CEO",
  //   profile:
  //     "Steve Okeleji’s experience in Aquaculture and Fisheries Management spans over 20 years. He founded FISH SHOAL NIGERIA over 12 years ago as a student, focusing on fingerlings and juvenile’s production and high production capacity.",
  //   link: "/advisory-council/steve-okeleji",
  // },
  {
    imgpath: iyadunni,
    name: "Iyadunni Olubode",
    title: "Advisor",
    profile:
      "Iyadunni Olubode has over fifteen (15) years’ experience consulting with a global firm and managing one of the biggest non-profit organizations in Nigeria and started her career in commercial bank and subsequently moved to management.",
    link: "/advisory-council/iyadunni-olubode",
  },
  {
    imgpath: adebayo,
    name: "Tope Adebayo",
    title: "Law Consultant",
    profile:
      "Tope is an alumnus of the Prestigious Harvard Kennedy School of Executive Education (Leaders in Development: Managing Change in a Dynamic World), He is an Attorney with vast experience in Dispute Resolution.",
    link: "/advisory-council/tope-adebayo",
  },
  // {
  //   imgpath: edna,
  //   name: "Edna Eligado Dionisio",
  //   title: "Technical Director",
  //   profile:
  //     "Edna is an accomplished Professional with prestigious experience of 33 years in spearheading cross-functional roles encompassing Technical Farm Management in Aquaculture and Fisheries with an inherent capability to formulate and implement tactical initiatives for achieving corporate goals.",
  //   link: "/advisory-council/edna-eligado-dianisio",
  // },
  // {
  //   imgpath: prof,
  //   name: "Prof. Yemi Akegbejo-Samsons",
  //   title: "Advisor",
  //   profile:
  //     "Prof Yemi Akegbejo-Samsons is currently a Professor of Aquaculture and Coastal Fisheries Management at the Federal University of Agriculture, Abeokuta (FUNAAB). He has worked at FUNAAB for over 20 years.",
  //   link: "/advisory-council/prof-yemi-akegbejo-samsoms",
  // },
  {
    imgpath: oluseun,
    name: "Oluseun Onigbinde",
    title: "Advisor",
    profile:
      "Oluseun Onigbinde, a graduate of Engineering from the University of Agriculture, Abeokuta, Nigeria, co-founded Nigeria’s civic tech organization, BudgIT in 2011. BudgIT uses technologies of any form that appeal across every literacy span.",
    link: "/advisory-council/oluseun-onigbinde",
  },
];

const Details = () => {
  return (
    <Box margin={{ xs: "30% 0%", sm: "5% 0%" }}>
      <Typography
        variant={"h3"}
        fontWeight={900}
        textAlign={"left"}
        color={"#00AEEF"}
        paddingBottom={"1%"}
      >
        <Typography
          component={"span"}
          variant={"h3"}
          color="#3E4095"
          fontWeight={900}
        >
          Our {""}
        </Typography>
        Advisory Council
      </Typography>
      <Typography
        variant={"body1"}
        fontWeight={400}
        textAlign={"left"}
        color={"#000"}
        paddingBottom={"2%"}
      >
        Our Advisory Council consist of seasoned experts in fields that are
        essential to what we do. We turn to these set of visionaries for advice
        and tutelage.
      </Typography>
      <Grid container spacing={1}>
        {data.map((list, index) => {
          const { imgpath, name, link, title, profile } = list;
          return (
            <>
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                marginTop={{ xs: "10%", sm: "3%" }}
                key={index}
              >
                <Card sx={{ maxWidth: 360, height: "100%" }}>
                  <CardActionArea href={link}>
                    <CardMedia
                      component="img"
                      height="340"
                      image={imgpath}
                      sx={{ objectFit: "cover" }}
                      alt={name}
                    />
                    <CardContent>
                      <Typography
                        gutterBottom
                        variant="h5"
                        color={"#3E4095"}
                        component="div"
                        fontWeight={700}
                        paddingBottom={"1%"}
                      >
                        {name}
                      </Typography>
                      <Typography
                        paddingBottom={"2%"}
                        variant="body2"
                        color="#00AEEF"
                        fontWeight={700}
                        data-aos={"fade-up"}
                      >
                        {title}
                      </Typography>
                      <Typography
                        paddingBottom={"5%"}
                        variant="body1"
                        color="text.secondary"
                        data-aos={"fade-up"}
                      >
                        {profile}
                      </Typography>
                      <Box
                        marginLeft={{ xs: " 0%", sm: "0%" }}
                        paddingTop={"2%"}
                      >
                        <Link
                          underline="none"
                          component="a"
                          href={link}
                          textAlign={"left"}
                          color="#00AEEF"
                          fontWeight={700}
                          sx={{
                            "&:hover": {
                              color: "#3E4095",
                            },
                          }}
                        >
                          Read More &#10140;
                        </Link>
                      </Box>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>
            </>
          );
        })}
      </Grid>
    </Box>
  );
};

export default Details;
